import { useMemo } from 'react';
import { useCustomFields } from './useCustomFields';
import { getClientIdWithFallback } from '../utils/customFieldUtils';
import { extractBroadSpecialtyOptions, Option } from '../utils/broadSpecialtyOptions';

type EntityType = 'Practice' | 'ProviderData';

interface UseBroadSpecialtyOptionsParams {
  entityType?: EntityType;
  clientId?: string | null;
}

export const useBroadSpecialtyOptions = ({
  entityType = 'ProviderData',
  clientId,
}: UseBroadSpecialtyOptionsParams = {}) => {
  const resolvedClientId = clientId ?? getClientIdWithFallback();

  const {
    customFields,
    loading,
    error,
    refresh,
  } = useCustomFields(resolvedClientId, entityType);

  const options: Option[] = useMemo(
    () => extractBroadSpecialtyOptions(customFields),
    [customFields]
  );

  return {
    options,
    loading,
    error,
    refresh,
  };
};

